import { FC } from "react";
import "./style.css";

interface Props {
  header: string;
  description: string;
}

export const PageHeader: FC<Props> = ({ header, description }) => {
  return (
    <div className="page-header">
      <h1>{header}</h1>
      <p>{description}</p>
    </div>
  );
};
